import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import App from "./App.tsx";
import "./i18n/config";
import { HelmetProvider } from "react-helmet-async";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

// Judul statis index.html hanya dipakai saat halaman tidak punya judul sendiri.
// React menambahkan <title> halaman tanpa menghapus yang statis, jadi harus dibersihkan di sini.
const fallbackTitle = document.head.querySelector("title")!;
const syncFallbackTitle = () => {
    const hasPageTitle = [...document.head.querySelectorAll("title")].some(
        (title) => title !== fallbackTitle,
    );
    if (hasPageTitle) fallbackTitle.remove();
    else if (!fallbackTitle.isConnected) document.head.append(fallbackTitle);
};
new MutationObserver(syncFallbackTitle).observe(document.head, {
    childList: true,
});

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </QueryClientProvider>
    </StrictMode>,
);
